/// <reference path="../include.ts" />

namespace project_guide {

	import Localizable = project_common.Localizable;

	export class GuideLocalizable {

		public static readonly drawerOpenButtonLabel:Localizable<string> = {
			"ja"     : "ゾーン",
			"en"     : "Zone",
			"ko"     : "존",
			"th"     : "โซน",
			"zh-hans": "区域",
			"zh-hant": "區域",
		};

		public static readonly cardViewCloseButtonLabel:Localizable<string> = {
			"ja"     : "展示種一覧",
			"en"     : "List of Exhibits",
			"ko"     : "전시종 목록",
			"th"     : "รายชื่อพันธุ์ที่จัดแสดง",
			"zh-hans": "展品种类一览",
			"zh-hant": "展示物種一覽表",
		};

		public static readonly cameraDescription:Localizable<string> = {
			"ja"     : "この水槽には水中カメラが設置されています",
			"en"     : "This water tank is equipped with an underwater camera.",
			"ko"     : "이 수조에는 수중 카메라가 설치되어 있습니다.",
			"th"     : "มีการติดตั้งกล้องใต้น้ำในแทงก์น้ำนี้",
			"zh-hans": "此水槽内设有水下相机。",
			"zh-hant": "這個水槽內設有水中攝影機。",
		};





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
